import { render, staticRenderFns } from "./EventTimelineItem.vue?vue&type=template&id=a56cfc12&scoped=true"
import script from "./EventTimelineItem.vue?vue&type=script&lang=js"
export * from "./EventTimelineItem.vue?vue&type=script&lang=js"
import style0 from "./EventTimelineItem.vue?vue&type=style&index=0&id=a56cfc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56cfc12",
  null
  
)

export default component.exports